'use strict';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styles from './Style';
import { Motion, spring, presets } from 'react-motion';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';

import ShareEmailModal from '../modals/ShareEmailModal';
import LogoComponent from './logo/LogoComponent';
import MenuContainer from './menu/MenuContainer';
import ExtendedMenuContainer from './menu/ExtendedMenuContainer';

import { isFullScreenAvailable } from '../helpers/fullscreen';
import * as mainActions from '../main/MainActions';
import * as appActions from '../app/AppActions';

class HeaderContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      homePageRegex: /\/([0-9]+)($|\/$)|(\/([0-9]+)\/(restricted|unbranded|branded))/,
      menuOpen: false
      // showMail: false
    };

    this.menuBtnClick = this.menuBtnClick.bind(this);
    this.fullscreenBtnClick = this.fullscreenBtnClick.bind(this);
  }

  menuBtnClick() {
    this.props.menuActions.menuBtnClick();
  }

  menuHandler = e => {
    this.setState({
      menuOpen: !this.state.menuOpen
    });
    if (e && e.currentTarget.title === 'Dashboard') {
      this.props.mainActions.setTimeoutStartComponent(true);
    }
  };

  logoRedirect = () => {
    this.props.appActions.redirectToHome(true);
  }


  fullscreenBtnClick() {
    if (isFullScreenAvailable()) {
      this.props.appActions.changeFullscreen(document.documentElement);
    }
  }

  showMailFormClick = () => {
    this.setState(
      { showMail: !this.state.showMail },
      () => this.state.showMail && this.menuHandler()
    );
  };

  render() {
    const baseUrl = this.props.tourType
      ? `/${this.props.tourId}/${this.props.tourType.charAt(0)}`
      : `/${this.props.tourId}`;
    return (
      <header
        className={
          baseUrl !== this.props.pathname
            ? styles.mainHeader
            : styles.headerDashboard
        }
      >
        <div className={styles.headerWrapper}>
          <LogoComponent
            logo={this.props.logo}
            logoTime={this.props.logoTime}
            startComponentRender={this.props.startComponentRender}
            baseUrl={baseUrl}
            logoRedirect={this.logoRedirect}
          />
          <MenuContainer />
          <div className={styles.btnMenu}>
            <button className={styles.btn} onClick={this.menuHandler}>
              MENU
              <FontAwesomeIcon className={styles.barsIcon} icon={faBars} />
            </button>
            {this.state.menuOpen && (
              <Motion defaultStyle={{ x: 100 }} style={{ x: spring(0) }}>
                {style => (
                  <ExtendedMenuContainer
                    menuHandler={this.menuHandler}
                    styles={{ transform: `translateX(${style.x}%` }}
                    showMailFormClick={this.showMailFormClick}
                  />
                )}
              </Motion>
            )}
            {this.state.showMail && (
              <Motion defaultStyle={{ y: 100 }} style={{ y: spring(0) }}>
                {animation => (
                  <ShareEmailModal
                    btnClick={this.showMailFormClick}
                    isOpened={this.state.showMail}
                    styles={{ transform: `translateX(${animation.y}%` }}
                  />
                )}
              </Motion>
            )}
          </div>
        </div>
      </header>
    );
  }
}

// HeaderContainer.propTypes = {
//     menuOpened: PropTypes.bool,
//     fullscreenEnabled: PropTypes.bool,
//     address: PropTypes.string,
//     pathname: PropTypes.string
// };

const mapStateToProps = state => {
  return {
    pathname: state.router.location.pathname,
    logo: state.agent.agentInfo.logo,
    logoTime: state.agent.agentInfo.logoTime,
    startComponentRender: state.main.startComponentRender,
    tourId: state.app.tourId,
    tourType: state.app.tourType
  };
};

const mapDispatchToProps = dispatch => {
  return {
    mainActions: bindActionCreators(mainActions, dispatch),
    appActions: bindActionCreators(appActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HeaderContainer);
